import DataTable from "datatables.net"
import 'datatables.net-searchbuilder'

// Move Resolve All `.actions` + DataTables `.dataTables_filter` UP into the
// `.portal-tabs` flex container so all three (tabs, resolve-all, search) live
// in a single flex-wrap row: they sit inline with the tabs on wide viewports
// and wrap naturally underneath on narrow ones — no breakpoint math.
function reconcileTabsRowControls() {
  const tabs = document.querySelector('#dashboard-tabs')
  if (!tabs) return

  const activePane = document.querySelector('#dashboard-tabsContent > .tab-pane.active')
  if (!activePane) return

  // Return any stray controls to their owning pane before hoisting the active
  // pane's controls up — otherwise the previous tab's Resolve All + search
  // would stay stuck in the tabs row after the user switches tabs.
  tabs.querySelectorAll(':scope > .actions').forEach((el) => {
    const owningPaneId = (el as HTMLElement).dataset.owningPane
    const owner = owningPaneId ? document.getElementById(owningPaneId) : null
    if (owner) owner.prepend(el)
  })
  tabs.querySelectorAll(':scope > .dataTables_filter').forEach((el) => {
    const owningPaneId = (el as HTMLElement).dataset.owningPane
    const wrapper = owningPaneId
      ? document.querySelector(`#${owningPaneId} .dataTables_wrapper`)
      : null
    if (wrapper) wrapper.prepend(el)
  })

  const actions = activePane.querySelector(':scope > .actions') as HTMLElement | null
  const filter = activePane.querySelector(':scope .dataTables_wrapper > .dataTables_filter') as HTMLElement | null

  if (actions) {
    actions.dataset.owningPane = activePane.id
    tabs.appendChild(actions)
  }
  if (filter) {
    filter.dataset.owningPane = activePane.id
    tabs.appendChild(filter)
  }
}

export default function() {
  if(document.getElementById('provisional-table') && document.getElementById('partners-table')) {
    const provisionalTable = new DataTable('#provisional-table', {
      info: false,
      paging: false,
      language: {
        search: '',
        searchPlaceholder: 'Search'
      },
    })

    $('#provisional-table tbody').on('click', '.resolve-access', function(event) {
      provisionalTable.row( $(this).closest('tr') ).remove().draw()
    })

    const partnersTable = new DataTable('#partners-table', {
      info: false,
      paging: false,
      language: {
        search: '',
        searchPlaceholder: 'Search'
      },
    })

    $('#partners-table tbody').on('click', '.resolve-access', function(event) {
      partnersTable.row( $(this).closest('tr') ).remove().draw()
    })

    reconcileTabsRowControls()
    $('#dashboard-tabs a[data-toggle="tab"]').on('shown.bs.tab', reconcileTabsRowControls)
  }
}
